import React, { useEffect, useState } from "react";
import { Paper, withStyles} from '@material-ui/core';
import MUIDataTable from "mui-datatables";
import { connect } from "react-redux";
import * as actions from "../../../actions/order";
import FormDialogAddOrder from "../formDialog/FormDialogAddOrder";
import FormDialogEditOrder from "../formDialog/FormDialogEditOrder";
import FormDialogDeleteOrder from "../formDialog/FormDialogDeleteOrder";
import moment from "moment";

const styles = theme => ({
    paperTable: {
        padding: theme.spacing(0),
    }
})

const OrderTable = ({ classes, ...props }) => {
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(15)
    const [isHomePage, setIsHomePage] = useState(props.CurrentPathname==="/admin/order"?false:true)

    useEffect(() => {
        props.fetchPagination(1, rowsPerPage, null, null, isHomePage)
    }, [])

    const handleChangePage = async (newPage) => {
        await setPage(newPage);
        props.fetchPagination(newPage + 1, rowsPerPage,null, null, isHomePage)
    };

    const handleChangeRowsPerPage = async (rowsPerPage) => {
        await setRowsPerPage(rowsPerPage);
        await setPage(0);
        props.fetchPagination(1, rowsPerPage,null, null, isHomePage)
    };

    const handleSearch = async (searchText) => {
        await setPage(0);
        props.fetchPagination(1, rowsPerPage, searchText, searchText, isHomePage)
    };

    const handleFilterChange = async (title,description) => {
        await setPage(0);
        props.fetchPagination(1, rowsPerPage, title, description, isHomePage)
    };

    const refresh = async () => {
        await setPage(0);
        props.fetchPagination(1, rowsPerPage,null,null,isHomePage)
    }
    
    const columns = [
        {
            name: "id",
            label: "ID",
            options: {
                display: false,
                filter: false,
                sort: false,
            }
        },
        {
            // left side of first column is too close with the container, give more space on it
            name: "transaction_no",
            label: "Transaction ID",
            options: {
                filter: true,
                sort: false,
                display: false,
                customHeadRender: (columnMeta, handleToggleColumn) => {
                    return (
                        <th key={columnMeta.index} 
                            style={{
                                paddingLeft: "31px", 
                                fontWeight:500, 
                                borderBottom: "1px solid rgba(224, 224, 224, .5)" 
                                }}
                        >
                            <div style={{display:"flex", flexDirection:"row", justifyContent:"flex-start"}}>
                                {columnMeta.label}
                            </div>
                        </th>
                    );
                },
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <span style={{marginLeft:15}}>
                            {value}
                        </span>
                    );
                }
            },
            
        },
      
        {
            name: "customer_name",
            label: "Customer Name",
            options: {
                filter: true,
                sort: false,
            }
        },
        {
            name: "customer_email",
            label: "Customer Email",
            options: {
                filter: true,
                sort: false,
            }
        },
        {
            name: "customer_mobile",
            label: "Customer Mobile",
            options: {
                filter: true,
                sort: false,
            }
        },
        
        {
            name: "customer_id",
            label: "customer_id",
            options: {
                filter: true,
                sort: false,
                display: false,
            }
        },
        {
            name: "transaction_amount",
            label: "Transaction Amount",
            options: {
                filter: true,
                sort: false,
              
            }
        },
        {
            name: "subTotal",
            label: "Sub Total",
            options: {
                filter: true,
                sort: false,
                display: false,
            }
        },
        {
            name: "discount",
            label: "Discount",
            options: {
                filter: true,
                sort: false,
                display: false,
            }
        },
        {
            name: "promocode",
            label: "Promocode",
            options: {
                filter: true,
                sort: false,
                display: false,
            }
        },
        {
            name: "orderedServices",
            label: "Ordered Services",
            options: {
                filter: true,
                sort: false,
                display: false,
            }
        },
        {
            name: "transaction_status",
            label: "Transaction Status",
            options: {
                filter: true,
                sort: false,
                display: false,
            }
        },
        {
            name: "order_status",
            label: "Order Status",
            options: {
                filter: true,
                sort: false,
            }
        },
        {
            name: "scheduleDate",
            label: "Appointment Date",
            options: {
                filter: true,
                sort: false,
                display: false,
                customBodyRender: (value, tableMeta, updateValue) =>  {
                    return moment(value).format('lll');
                }
            }
        },
        {
            name: "note",
            label: "Note",
            options: {
                filter: true,
                sort: false,
                display: false,
            }
        },
        {
            name: "createdOn",
            label: "Created on",
            options: {
                filter: true,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) =>  {
                    return moment(value).format('lll');
                }
            }
        },
        {
            name: "scheduledServices",
            label: "Scheduled Services",
            options: {
                filter: true,
                sort: false,
                display: false,
            }
        },
        {
            name: "orderID",
            label: "Order ID",
            options: {
                filter: true,
                sort: false,
            }
        },
       
        // {
        //     name: "createdDate",
        //     label: "Registration Date",
        //     options: {
        //         filter: false,
        //         sort: false,
        //     }
        // },
        {
            name: "",
            options: {
                filter: false,
                sort: false,
                empty: true,
                customHeadRender: (columnMeta, handleToggleColumn) => {
                    return (
                        <th key={columnMeta.index} style={{paddingRight: "16px"}}>
                            {/* <div style={{display:"flex", flexDirection:"row", justifyContent:"flex-end"}}>
                                <FormDialogAddOrder component={Paper}  
                                    create={props.create}
                                    refresh={refresh}
                                />
                            </div> */}
                            Actions
                        </th>
                    );
                },
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <div style={{display:"flex", flexDirection:"row", justifyContent:"flex-end"}}>
                            <FormDialogEditOrder
                                dataOrder={tableMeta.rowData}
                                update={props.update}
                            />
                            <FormDialogDeleteOrder 
                                dataOrder={tableMeta.rowData}
                                delete={props.delete}
                                refresh={refresh}
                            />
                        </div>
                    );
                }
            }
        }
    ];

    const options = {
        filter: false,
     
        filterType: 'textField',
        responsive: 'stacked',
        selectableRows: false,
        rowsPerPageOptions: [5, 10, 25],
        serverSide: true,
        viewColumns: false,
        print: false,
        download: true,
        downloadOptions: {
            filename: 'adameve_orders.csv',
            separator: ';',
            filterOptions: {
              useDisplayedColumnsOnly: true,
              useDisplayedRowsOnly: false,
            }
        },
        rowsPerPage: rowsPerPage,
        count: props?.meta?.totalDocs || 0,
        page: page,

        onTableChange: (action, tableState) => {
            switch (action) {
              case 'changePage':
                handleChangePage(tableState.page)
                break;

            case 'changeRowsPerPage':
                handleChangeRowsPerPage(tableState.rowsPerPage)
                break;

            case 'search':
                handleSearch(tableState.searchText)
                break;

            case 'filterChange':
                handleFilterChange(tableState.filterList[1], tableState.filterList[2])
                break;
            
            case 'resetFilters':
                handleSearch("")
                break;
                 
              default:
                break;
            }
        },
    };
    
    return (
        <MUIDataTable className={classes.paperTable}
            data={props.orders}
            columns={columns}
            options={options}
        />
    );
}

const mapStateToProps = state => ({
    orders: state?.order?.orders,
    meta: state?.order?.metaOrder
})

const mapActionToProps = {
    fetchPagination: actions.Pagination,
    create: actions.create,
    update: actions.update,
    delete: actions.Delete
}

export default connect(mapStateToProps, mapActionToProps)(withStyles(styles)(OrderTable));